import React, { useEffect, useState } from "react";
import { Button, Input, Modal, ModalFooter, ModalHeader, Checkbox, Field } from "modules/common";
import {
    UseCreatePhytoViewEntry,
    UseEditPhytoViewEntry,
    useGetOnePhytoView,
} from "../../hooks/phytoViewHook";
import { IPhytoViewModalProps } from "views";
import { PhytoviewRequest } from "services/phytoview";

const emptyPhytoView: PhytoviewRequest = {
    name: "",
    description: "",
    active: false,
};

const validateGospJediniceRecord = (phytoview: PhytoviewRequest): Record<string, string> => {
    const errors: Record<string, string> = {};
    if (!phytoview.name.trim()) {
        errors.name = "Naziv je obavezan";
    }
    return errors;
};

const PhytoViewGospodarskeJediniceModal: React.FC<IPhytoViewModalProps> = ({
    title,
    isOpen,
    onClose,
    isPost,
    editItemId,
}) => {
    const endpoint = "GospodarskeJedinice";
    const [, setIsEdit] = useState(false);
    const [phytoview, setPhytoview] = useState<PhytoviewRequest>(emptyPhytoView);
    const [isFormChanged, setIsFormChanged] = useState(false);
    const [errors, setErrors] = useState<Record<string, string>>({});
    const { data: dataOne } = useGetOnePhytoView(endpoint, editItemId);
    const create = UseCreatePhytoViewEntry(endpoint);
    const edit = UseEditPhytoViewEntry(endpoint, editItemId);
    const inputReset = () => {
        setPhytoview({ ...emptyPhytoView });
        setErrors({});
    };
    useEffect(() => {
        if (!isPost && isOpen && dataOne) {
            setPhytoview(prev => ({
                ...prev,
                active: dataOne.active ?? true,
                name: dataOne.name ?? "",
                description: dataOne.description ?? "",
            }));
        } else {
            inputReset();
        }
    }, [isPost, isOpen, dataOne]);
    if (!isOpen) return null;
    const onCancel = () => {
        inputReset();
        setIsEdit(false);
        setIsFormChanged(false);
        onClose();
    };
    const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { checked } = event.target;
        setPhytoview(prev => ({ ...prev, active: checked }));
        setIsFormChanged(true);
    };

    const isValid = (property: string) => {
        return !errors[property];
    };
    const getErrorMsg = (property: string) => {
        return errors[property] ?? "";
    };
    const onSave = async () => {
        const newErrors = validateGospJediniceRecord(phytoview);
        if (Object.keys(newErrors).length) {
            setErrors(newErrors);
            return;
        }
        setErrors({});

        const payload: PhytoviewRequest = {
            name: phytoview.name,
            description: phytoview.description,
            active: phytoview.active,
            naziv: "",
        };
        const mutation = isPost ? create.mutateAsync : edit.mutateAsync;
        await mutation(payload);
        inputReset();
        onClose();
    };
    return (
        <Modal
            isActive={isOpen}
            className="phytoview-details-modal"
            onClose={onClose}
            modalHeader={
                <ModalHeader onClose={onClose} title={title} className="phytoview-modal-header" />
            }
            modalFooter={
                <ModalFooter>
                    <div className="phytoview-footer">
                        <Button
                            type="button"
                            size="small"
                            variant="primary-ghost"
                            onClick={onCancel}
                        >
                            <span>ODUSTANI</span>
                        </Button>
                        <Button
                            type="button"
                            size="small"
                            variant="primary"
                            disabled={!isFormChanged}
                            onClick={onSave}
                        >
                            <span>SPREMI</span>
                        </Button>
                    </div>
                </ModalFooter>
            }
        >
            <div className="phytoview-details">
                <div className="modal-section">
                    <Field name="NAZIV" errorMessage={getErrorMsg("name")}>
                        <Input
                            size="small"
                            name="name_input_filed"
                            id="name_id"
                            type="text"
                            isValid={isValid("name")}
                            value={phytoview?.name}
                            onChange={e => {
                                setPhytoview({ ...phytoview, name: e.target.value });
                                setIsFormChanged(true);
                            }}
                        />
                    </Field>
                </div>
                <div className="modal-section">
                    <Field name="OPIS">
                        <Input
                            size="large"
                            name="desc_input_filed"
                            id="desc_id"
                            type="text"
                            isValid={true}
                            value={phytoview.description}
                            onChange={e => {
                                setPhytoview({ ...phytoview, description: e.target.value });
                                setIsFormChanged(true);
                            }}
                        />
                    </Field>
                </div>
                <div className="modal-section">
                    <Field name="AKTIVAN">
                        <Checkbox
                            isChecked={phytoview.active}
                            type="checkbox"
                            htmlFor="example-checkbox"
                            text="Da"
                            onChange={handleCheckboxChange}
                            className="custom-checkbox"
                            value="checkbox-value"
                            isReversed={true}
                        />
                    </Field>
                </div>
            </div>
        </Modal>
    );
};

export default PhytoViewGospodarskeJediniceModal;
